import * as yup from 'yup'

export const wooCommerceUpdateProductDataSchema = yup.object({
  productId: yup.string().nullable(),
  variantId: yup.string().nullable(),
  productName: yup.string().nullable(),
  variantName: yup.string().nullable(),
  stockQuantity: yup.number().required(),
})
export type WooCommerceUpdateProductData = yup.InferType<typeof wooCommerceUpdateProductDataSchema>

// WooCommerce Read Orders Integration Types
export interface WooCommerceAddress {
  first_name: string
  last_name: string
  company: string
  address_1: string
  address_2: string
  city: string
  state: string
  postcode: string
  country: string
  email?: string
  phone?: string
}

export interface WooCommerceMetaData {
  id: number
  key: string
  value: string
}

export interface WooCommerceTax {
  id: number
  total: string
  subtotal: string
}

export interface WooCommerceLineItem {
  id: number
  name: string
  product_id: number
  variation_id: number
  quantity: number
  tax_class: string
  subtotal: string
  subtotal_tax: string
  total: string
  total_tax: string
  taxes: WooCommerceTax[]
  meta_data: WooCommerceMetaData[]
  sku: string
  price: number
}

export interface WooCommerceTaxLine {
  id: number
  rate_code: string
  rate_id: number
  label: string
  compound: boolean
  tax_total: string
  shipping_tax_total: string
  meta_data: WooCommerceMetaData[]
}

export interface WooCommerceShippingLine {
  id: number
  method_title: string
  method_id: string
  total: string
  total_tax: string
  taxes: WooCommerceTax[]
  meta_data: WooCommerceMetaData[]
}

export interface WooCommerceFeeLine {
  id: number
  name: string
  tax_class: string
  tax_status: string
  total: string
  total_tax: string
  taxes: WooCommerceTax[]
  meta_data: WooCommerceMetaData[]
}

export interface WooCommerceCouponLine {
  id: number
  code: string
  discount: string
  discount_tax: string
  meta_data: WooCommerceMetaData[]
}

export interface WooCommerceRefund {
  id: number
  reason: string
  total: string
}

export interface WooCommerceOrderLink {
  href: string
  embeddable?: boolean
}

export interface WooCommerceOrderLinks {
  self: WooCommerceOrderLink[]
  collection: WooCommerceOrderLink[]
  email_templates?: WooCommerceOrderLink[]
  customer?: WooCommerceOrderLink[]
}

export interface WooCommerceOrder {
  id: number
  parent_id: number
  number: string
  order_key: string
  created_via: string
  version: string
  status: string
  currency: string
  date_created: string
  date_created_gmt: string
  date_modified: string
  date_modified_gmt: string
  discount_total: string
  discount_tax: string
  shipping_total: string
  shipping_tax: string
  cart_tax: string
  total: string
  total_tax: string
  prices_include_tax: boolean
  customer_id: number
  customer_ip_address: string
  customer_user_agent: string
  customer_note: string
  billing: WooCommerceAddress
  shipping: WooCommerceAddress
  payment_method: string
  payment_method_title: string
  transaction_id: string
  date_paid: string | null
  date_paid_gmt: string | null
  date_completed: string | null
  date_completed_gmt: string | null
  cart_hash: string
  meta_data: WooCommerceMetaData[]
  line_items: WooCommerceLineItem[]
  tax_lines: WooCommerceTaxLine[]
  shipping_lines: WooCommerceShippingLine[]
  fee_lines: WooCommerceFeeLine[]
  coupon_lines: WooCommerceCouponLine[]
  refunds: WooCommerceRefund[]
  _links: WooCommerceOrderLinks
}

export interface WooCommerceReadOrdersInput {
  context?: 'view' | 'edit'
  page?: number
  per_page?: number
  search?: string
  after?: string
  before?: string
  modified_after?: string
  modified_before?: string
  dates_are_gmt?: boolean
  exclude?: number[]
  include?: number[]
  offset?: number
  order?: 'asc' | 'desc'
  orderby?: 'date' | 'modified' | 'id' | 'include' | 'title' | 'slug'
  parent?: number[]
  parent_exclude?: number[]
  status?: (
    | 'any'
    | 'pending'
    | 'processing'
    | 'on-hold'
    | 'completed'
    | 'cancelled'
    | 'refunded'
    | 'failed'
    | 'trash'
  )[]
  customer?: number
  product?: number
  dp?: number
  created_via?: string
}

export interface WooCommerceReadOrdersResponse {
  orders: WooCommerceOrder[]
  totalRecords?: number
  totalPages?: number
}
